import React from 'react';
import Text from 'components/core/Text';
import ProgramPreview from '../ProgramPreview';
import LinkIcon from '../../../LinkIcon';

import {
  OtherPrograms,
  CustomSimpleBar,
  OtherProgram,
  Information,
  InformationTitle,
  SessionInformation,
} from './styles';

const ProgramsList = ({ programs }) => {
  const renderOtherProgram = (program) => {
    const {
      id: programId,
      nextSession,
      completedSessionsCount,
      nextTrackSessionId,
      sessionsCount,
      programTrack,
      isExternal,
      externalLink,
    } = program;
    let linkHref;

    if (isExternal) {
      linkHref = externalLink;
    } else {
      linkHref = `/programs/${programId}/sessions/${nextSession?.id}${
        nextTrackSessionId ? `?trackSessionId=${nextTrackSessionId}` : ''
      }`;
      if (!nextSession?.id || completedSessionsCount === 0) {
        linkHref = `/programs/${programId}`;
      }
    }

    const programTrackSessions = programTrack?.programTrackSessions;
    const nextSessionIdx = programTrackSessions?.findIndex((pts) => pts.id === nextTrackSessionId);
    const isLoopingProgram = programTrack?.loopBackToTrackSessionId != null;
    const sessionDaysCompleted = (nextSessionIdx / (sessionsCount - 1)) * 100;

    return (
      <OtherProgram
        key={programId}
        href={linkHref}
        sessionDaysCompleted={sessionDaysCompleted}
        isLooping={isLoopingProgram}
      >
        {isExternal && <LinkIcon isSmall />}
        <ProgramPreview program={program} size="280x162" />
        <Information>
          {!isExternal && (
            <SessionInformation>
              <Text variant="caption" tag="h4" weight="medium" color="white" mr={4} withShadow>
                <span>{nextSession?.name}</span>
              </Text>
            </SessionInformation>
          )}
          <InformationTitle name="information-title">{program.name}</InformationTitle>
        </Information>
      </OtherProgram>
    );
  };

  if (!programs.length) {
    return null;
  }

  return (
    <OtherPrograms>
      <CustomSimpleBar>{programs.map((item) => renderOtherProgram(item))}</CustomSimpleBar>
    </OtherPrograms>
  );
};

export default ProgramsList;
